//*************************************************************************************
//* Session specific code
//*
//* 6/13/18 Kraus    [COM-136]: Created
//*************************************************************************************

app.Committee = (function () {
    var myCommittee = {
        Index: function () {
            $("#committee-grid").kendoGrid(
                {
                    columns: [
                        {
                            field: "CommitteeId",
                            hidden: true
                        },
                        {
                            field: "Name",
                            title: "Title",
                            width: "200px"
                        },
                        {
                            field: "CommitteeType",
                            title: "Committee Type",
                            //width: "150px"
                        },
                        {
                            field: "HrType",
                            title: "HR Type",
                            //width: "150px"
                        },
                        {
                            field: "hasVacancies",
                            title: "Vacancies",
                            //width: "60px"
                        },
                        {
                            field: "Members",
                            title: "Seat Count",
                            //width: "75px"
                        },
                        {
                            template: "<a class='uw-button uw-button-inverse' href='/Committee/Details/#=CommitteeId#'>Details</a>"
                        }],
                    toolbar: ["excel"],
                    excel: {
                        fileName: "AllCommittees" + app.Committee.ConvertDate(new Date()) + ".xlsx"
                    },
                    scrollable: false,
                    sortable: true,
                    columnMenu: true,
                    groupable: {
                        messages: {
                            empty: "Drop columns here to group by"
                        }
                    }
                });

            app.KendoGrids.InitPersistentGrid("committee-grid", true);
            //$(document).ready(function () {
            //    $("#txtCommitteeSeatExpectedStartDate").on('change', function () {
            //        var startDate = new Date($("#txtCommitteeSeatExpectedStartDate").val());
            //        var defaultTermLength = parseInt($("#hdnDefaultTerm").val());
            //        var endDate = new Date(startDate.setYear(startDate.getFullYear() + defaultTermLength));
            //        endDate.setDate(endDate.getDate() - 1);
            //        $("#txtCommitteeSeatExpectedEndDate").val(endDate.toLocaleDateString());
            //    });
            //});
        },
        Details: function () {
            app.Prospective.Init("gridProspectiveMember");
            app.Committee.InitCommitteeSeatEdit();
            app.Committee.InitFileTypeCopy();
            app.Committee.InitAutoDateUpdate();
            
            $(document).on('click', "[data-role='add-committee-seat']",
                function (e) {
                    app.Committee.EditCommitteeSeatDetails(e);
                });
            $(document).on('click', "[data-role='update-committee-seat']",
                function () {
                    app.Committee.UpdateCommitteeSeat(this, $(this).data('post-url'));
                });
            $(document).on('click', "[data-role='toggle-private-documents']",
                function () {
                    var componentTypeTarget = $(this).data('component-target');
                    var publicDocs = $('[data-role="file-upload-view"][data-is-private="False"]', $('[data-component-type="' + componentTypeTarget + '"]'));

                    if ($(this).html().toLowerCase().indexOf("only") > 0) {
                        //hide docs
                        publicDocs.closest(".card").hide();
                        $(this).html('Show all Documents');
                    }
                    else {
                        publicDocs.closest(".card").show();
                        $(this).html('Show Only Private Documents');
                    }
                });

            var isAdmin = $("#gridSeatHistory").data('is-admin') == 'True';
            var gridColumns = [{
                field: "Chair",
                title: "Chair"
            },
            {
                field: "Title",
                title: "Title",
                hidden: true
            },
            {
                field: "DepartmentName",
                title: "Department Name"
            },
            {
                field: "Division",
                title: "Division",
                hidden: true
            },
            {
                field: "Department",
                title: "Department",
                hidden: true
            },
            {
                field: "Subdepartment",
                title: "Subdepartment",
                hidden: true
            },
            {
                field: "SeatType",
                title: "Seat Type"
            },
            {
                field: "FillCommitteeSeatType",
                title: "Fill Type",
                hidden: true
            },
            {
                field: "FillAuthorityCommitteeSeatType",
                title: "Fill Authority",
                hidden: true
            },
            {
                field: "FacultyDivision",
                title: "Faculty Seat Division",
                hidden: true
            },
            {
                field: "SeatMemberFacultyDivision",
                title: "Faculty Division",
                hidden: true
            },
            {
                field: "District",
                title: "District",
                hidden: true
            }];


            if (isAdmin) {
                gridColumns.splice(0, 0,
                    {
                        field: "SeatMemberId",
                        title: "Seat Member Id",
                        hidden: true

                    },
                    {
                        field: "FirstName",
                        title: "First Name",
                        template: "# if(UserAddress != ''){#<a href='#:UserAddress#'>#:FirstName#</a>#}else{#<div>#:FirstName#</div>#}#"

                    },
                    {
                        field: "LastName",
                        title: "Last Name",
                        template: "# if(UserAddress != ''){#<a href='#:UserAddress#'>#:LastName#</a>#}else{#<div>#:LastName#</div>#}#"

                    });
            }
            else {
                gridColumns.splice(0, 0,
                    {
                        field: "FirstName",
                        title: "First Name"
                    },
                    {
                        field: "LastName",
                        title: "Last Name"
                    });
            }


            if (isAdmin) {
                gridColumns.push({
                    field: "AdminNotes",
                    title: "Admin Notes"
                });
                gridColumns.push({
                    field: "SeatNumber",
                    title: "Seat Number",
                    type: "number"
                });
            }
            gridColumns.splice(gridColumns.length, 0,
                {
                    field: "ExpectedStart",
                    title: "Exp. Start",
                    format: "{0:M/d/yyyy}",
                    hidden: true
                },
                {
                    field: "ActualStart",
                    title: "Act. Start",
                    format: "{0:M/d/yyyy}"
                },
                {
                    field: "ExpectedEnd",
                    title: "Exp. End",
                    format: "{0:M/d/yyyy}"
                },
                {
                    field: "ActualEnd",
                    title: "Act. End",
                    format: "{0:M/d/yyyy}",
                    hidden: true
                });

            if (isAdmin) {
                gridColumns.push({
                    template: "<a target='_blank' class='button tiny info remove-rounded-corners' href='/Committee/SeatDetails/#=CommitteeId#/#=SeatMemberId#'>Details</a>"
                });
            }

            $("#gridSeatHistory").kendoGrid(
                {
                    dataSource: {
                        schema: {
                            model: {
                                fields: {
                                    District: { type: "number" },
                                    SeatNumber: { type: "number" },
                                    ActualEnd: { type: "date" },
                                    ExpectedEnd: { type: "date" },
                                    ExpectedStart: { type: "date" },
                                    ActualStart: { type: "date" }
                                }
                            }
                        }
                    },
                    filterable: {

                        extra: false,
                        operators: {
                            string: {
                                startswith: "Starts with",
                                eq: "Is equal to",
                                neq: "Is not equal to"
                            }
                        }
                    },
                    toolbar: ["excel"],
                    excel: {
                        fileName: ""
                    },
                    columns: gridColumns,
                    noRecords: true,
                    scrollable: false,
                    sortable: true,
                    columnMenu: true,
                });
            app.KendoGrids.InitPersistentGrid("gridSeatHistory", true);
        },
        SeatHistoryFileName: function () {
            return $('[data-role-name="committee-date"]').val().replace(/\//g, "-") + ".xlsx";
        },
        SeatDetails: function () {
            app.Committee.InitCommitteeSeatEdit();
            $(document).on('component-bind-edit-mode-complete',
                function (e) {
                    app.Committee.ToggleSeatOption($("[data-role='committee-seat-type']"));
                });
            app.Committee.InitAutoDateUpdate();
            $(document).on("component-remove-complete-CommitteeSeat", function (e, component) {
                window.location.replace("/Committee/Details/" + app.page.committeeId);
            });
            $(document).on('click', "[data-role='update-seat-members']",
                function () {
                    app.Committee.UpdateSeatMember(this, $(this).data('post-url'));
                });
            $(document).on('click', "[data-role='remove-seat-members']",
                function () {
                    app.Committee.RemoveSeatMember(this, $(this).data('post-url'));
                });
            $(document).on("component-remove-complete-SeatMember", function (e, component) {
                window.location.replace("/Committee/SeatDetails/" + app.page.committeeId + "/" + app.page.id);
            });

            $(document).on('click', "[data-role='add-seat-members']",
                function (e) {
                    app.Committee.EditSeatMemberDetails(e);
                });
            app.Committee.InitSeatMemberHistory();
            $(document).on('component-save-complete-SeatMember', function () {
                app.KendoGrids.GetResults("gridSeatMemberHistory");
            });
            $(document).on('change', '[data-role="is-successor"]', function () {
                //toggle successor form based on checkbox
                if ($(this).prop('checked')) {
                    $(this).closest('form').find('[data-role="successor-form"]').show(200);
                }
                else {
                    $(this).closest('form').find('[data-role="successor-form"]').hide();
                    $(this).closest('form').find('[data-role="successor-form"]').find('input, select')
                        .not('button, submit, reset, hidden, [type="button"]')
                        .val('')
                        .removeAttr('checked')
                        .removeAttr('selected');
                }
            });
            app.Committee.InitSeatMemberFlags();
            $(document).on("component-save-complete-SeatMember", function (e, component) {
                //refresh page if the new component id is -1
                if (component.id == -1) {
                    window.location.replace("/Committee/SeatDetails/" + app.page.committeeId + "/" + app.page.id);
                }
            });
        },
        InitCommitteeSeatEdit: function () {
            $(document).on('change', "[data-role='committee-seat-type']",
                function (e) {
                    app.Committee.ToggleSeatOption(this);
                });
        },
        InitFileTypeCopy: function () {
            $(document).on('change', "[data-role='file-type']",
                function (e) {
                    $(this).closest('form').find("[data-role='file-display-name']").val($(this).children("option:selected").text());
                });
        },
        InitAutoDateUpdate: function () {
            $(document).on('change', "[data-default-term-length-start]", function () {
                var autoTermUpdateWrapper = $(this).closest('[data-role="auto-term-update"]');
                var startDate = new Date($(this).val());
                $("[name*=Start]", autoTermUpdateWrapper).val(startDate.toLocaleDateString());
                var defaultTermLength = parseInt($(autoTermUpdateWrapper).data("default-term-length"));
                var endDate = new Date(startDate.setYear(startDate.getFullYear() + defaultTermLength));
                endDate.setDate(endDate.getDate() - 1);
                $("[name*=End]", autoTermUpdateWrapper).val(endDate.toLocaleDateString());
            });
        },
        ToggleSeatOption: function (ddl) {
            var numberRequired = $("option:selected", ddl).data("number-required");
            var divisionRequired = $("option:selected", ddl).data("division-required");
            if (numberRequired == 'False') {
                $('[data-role="seat-number"]').hide();
                $('[data-role="seat-number"]').find('select').val('');
            }
            else if (numberRequired == 'True') {
                $('[data-role="seat-number"]').slideDown(200);
            }

            if (divisionRequired != 'True') {
                $('[data-role="faculty-division"]').hide();
                $('[data-role="faculty-division"]').find('select').val('');
            }
            else if (divisionRequired == 'True') {
                $('[data-role="faculty-division"]').slideDown(200);
            }
        },
        Sorting: function (arg) {
            console.log("The group to be expanded: " + kendo.stringify(arg.sort.field));
        },
        EditSeatMemberDetails: function (e) {
            e.preventDefault();

            $('[data-role="edit-seat-member-wrapper"]').html('');
            $('[data-role="edit-seat-member-wrapper"]').addClass('popup-loading');
            $('#editSeatMemberModal').foundation('open');
            var SeatMemberId = $(e.currentTarget).closest("tr").find('td:hidden').first().text();

            if (SeatMemberId === "") {
                SeatMemberId = "0";
            }

            $.ajax({
                type: 'POST',
                dataType: 'html',
                url: $("#gridSeatMemberHistory").data("post-url"),
                data: JSON.stringify({
                    'Id': SeatMemberId,
                    'CommitteeSeatId': app.page.id
                }),
                contentType: "application/json; charset=utf-8",
                success: function (partialViewResult) {
                    $('[data-role="edit-seat-member-wrapper"]').html(partialViewResult);
                    app.input.initDatePicker($('[data-role="edit-seat-member-wrapper"]'));
                    $('[data-role="edit-seat-member-wrapper"]').removeClass('popup-loading');
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    toastr.error('Error loading seat member details.', 'Error');
                    console.log('Error: ' + jqXHR + ", textStatus: " + textStatus + ", errorThrown: " + errorThrown);
                    console.log(JSON.stringify(jqXHR));
                    $('#editSeatMemberModal').foundation('close');
                }
            });
        },
        RemoveSeatMember: function (button, url) {
            if (confirm("Are you sure you want to delete this Seat Member?")) {
                var SeatMemberId = $(button).closest('.reveal').find('form').find('[data-role="seat-member-id"]').val();

                if (SeatMemberId === "") {
                    SeatMemberId = "0";
                }

                $.ajax({
                    type: 'POST',
                    url: url,
                    data: JSON.stringify({
                        'Id': SeatMemberId,
                        'controllerId': app.page.id
                    }),
                    contentType: "application/json; charset=utf-8",
                    success: function (partialViewResult) {
                        $('#editSeatMemberModal').foundation('close');
                        app.KendoGrids.GetResults("gridSeatMemberHistory");
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        toastr.error('Error loading seat member details.', 'Error');
                        console.log('Error: ' + jqXHR + ", textStatus: " + textStatus + ", errorThrown: " + errorThrown);
                        console.log(JSON.stringify(jqXHR));
                    }
                });
            }
        },
        UpdateSeatMember: function (button, url) {
            var form = $(button).closest('.reveal').find('form');
            $.validator.unobtrusive.parse(form);

            console.log(form.valid());
            if (form.valid()) {

                $.ajax({
                    url: url,
                    type: 'POST',
                    data: form.serialize() + "&netid=" + $(button).closest('form').find('[data-role="netid"]').val(),
                    async: false,
                    success: function (partialViewResult) {
                        toastr.success('Seat Member was saved successfully!', 'Save Successful');
                        //getActivityLogResults();

                        //update the grid to reflect an changes
                        app.KendoGrids.GetResults("gridSeatMemberHistory");

                        //close the popup.
                        $('#editSeatMemberModal').foundation('close');
                    },
                    error: function (result) {
                        toastr.error('There was an error while saving the seat member.', 'Error');
                    }
                });
            }
            else {
                //Give focus to the first error
                var firstError = $('#' + $('.field-validation-error', form).data('valmsg-for'));
                if (firstError.length) {
                    $('html, body').animate({
                        scrollTop: firstError.offset().top - 50
                    }, 500);
                }
            }
        },
        InitSeatMemberHistory: function () {
            var isAdmin = $("#gridSeatMemberHistory").data('is-admin') == 'True';
            $("#gridSeatMemberHistory").kendoGrid({
                filterable: {
                    extra: false,
                    operators: {
                        string: {
                            startswith: "Starts with",
                            eq: "Is equal to",
                            neq: "Is not equal to"
                        }
                    }
                },
                toolbar: ["excel"],
                excel: {
                    fileName: ""
                },
                columns: [
                    {
                        field: "SeatMemberId",
                        title: "Seat Member Id",
                        hidden: true
                    },
                    {
                        field: "FirstName",
                        title: "First Name",
                        template: isAdmin ? "<a href='#=UserAddress#'>#=FirstName#</a>" : null
                    },
                    {
                        field: "LastName",
                        title: "Last Name",
                        template: isAdmin ? "<a href='#=UserAddress#'>#=LastName#</a>" : null
                    },
                    {
                        field: "Chair",
                        title: "Chair"
                    },
                    {
                        field: "Title",
                        title: "Title"
                    },
                    {
                        field: "DepartmentName",
                        title: "Department Name"
                    },
                    {
                        field: "Division",
                        title: "Division",
                        hidden: true
                    },
                    {
                        field: "Department",
                        title: "Department",
                        hidden: true
                    },
                    {
                        field: "Subdepartment",
                        title: "Subdepartment",
                        hidden: true
                    },
                    {
                        field: "District",
                        title: "District",
                        hidden: true
                    },
                    {
                        field: "ActualStart",
                        title: "Act. Start",
                        format: "{0:M/d/yyyy}"
                    },
                    {
                        field: "ActualEnd",
                        title: "Act. End",
                        format: "{0:M/d/yyyy}"
                    },
                    {
                        template: "<button type='button' data-role='edit-seat-member' class='button info remove-rounded-corners'>Edit</button>"
                    }],
                noRecords: true,
                dataSource: {
                    schema: {
                        model: {
                            fields: {
                                ActualEnd: { type: "date" },
                                ActualStart: { type: "date" },
                                Division: { type: "number" }
                            }
                        }
                    }
                },
                scrollable: false,
                width: 100,
                sortable: true,
                columnMenu: true,
                groupable: {
                    messages: {
                        empty: "Drop columns here to group by"
                    }
                }
            });
            app.KendoGrids.InitPersistentGrid("gridSeatMemberHistory", true);
            $("#gridSeatMemberHistory").on("click", "[data-role='edit-seat-member']", function (e) { app.Committee.EditSeatMemberDetails(e); });
        },
        EditCommitteeSeatDetails: function (e) {
            e.preventDefault();
            committeeSeatId = "0";
            $('[data-role="add-committee-seat-member-wrapper"]').html('');
            $('[data-role="add-committee-seat-member-wrapper"]').addClass('popup-loading');
            $('#addCommitteeSeatMemberModal').foundation('open');
            $.ajax({
                type: 'POST',
                dataType: 'html',
                url: $("[data-role='add-committee-seat']").data("post-url"),
                data: JSON.stringify({
                    'Id': committeeSeatId,
                    'CommitteeId': app.page.id
                }),
                contentType: "application/json; charset=utf-8",
                success: function (partialViewResult) {
                    $('[data-role="add-committee-seat-member-wrapper"]').html(partialViewResult);
                    app.input.initDatePicker($('[data-role="add-committee-seat-member-wrapper"]'));
                    $('[data-role="add-committee-seat-member-wrapper"]').removeClass('popup-loading');
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    toastr.error('Error loading committee seat details.', 'Error');
                    console.log('Error: ' + jqXHR + ", textStatus: " + textStatus + ", errorThrown: " + errorThrown);
                    console.log(JSON.stringify(jqXHR));
                }
            });
        },
        UpdateCommitteeSeat: function (button, url) {
            var form = $(button).closest('.reveal').find('form');
            $.validator.unobtrusive.parse(form);

            console.log(form.valid());
            if (form.valid()) {
                $.ajax({
                    url: url,
                    type: 'POST',
                    data: form.serialize() + "&netid=" + $(button).closest('form').find('[data-role="netid"]').val(),
                    async: false,
                    success: function (partialViewResult) {
                        toastr.success('Committee Seat was saved successfully!', 'Save Successful');

                        //update the grid to reflect an changes
                        app.KendoGrids.GetResults("gridSeatHistory");

                        //close the popup.
                        $('#addCommitteeSeatMemberModal').foundation('close');
                    },
                    error: function (result) {
                        toastr.error('There was an error while saving the committee seat.', 'Error');
                    }
                });
            }
            else {
                //Give focus to the first error
                var firstError = $('#' + $('.field-validation-error', form).data('valmsg-for'));
                if (firstError.length) {
                    $('html, body').animate({
                        scrollTop: firstError.offset().top - 50
                    }, 500);
                }
            }
        },
        InitSeatMemberFlags: function () {
            $(document).on('click', '[data-role="add-flag"]', function () {
                var template = $(this).closest('[data-role="flag-edit-form"]').find("[data-role='flag-template']").html();
                template = template.replace(/#=name#/g, $(this).closest('[data-role="flag-edit-form"]').find('[name="FlagTypes"] option:selected').text());
                template = template.replace(/#=flagTypeId#/g, $(this).closest('[data-role="flag-edit-form"]').find('[name="FlagTypes"] option:selected').val());
                template = template.replace(/#=index#/g, $(this).closest('[data-role="flag-edit-form"]').find('[data-role="flag"]').length - 1);
                $(this).closest('[data-role="flag-edit-form"]').find('[name="FlagTypes"] option:selected').remove();
                if ($(this).closest('[data-role="flag-edit-form"]').find('[name="FlagTypes"] option').length === 0) {
                    $(this).closest('[data-role="flag-edit-form"]').find('[data-role="add-flags"]').hide();
                }
                var flags = $(this).closest('[data-role="flag-edit-form"]').find('[data-role="flags"]');
                flags.show();
                flags.append(template);
            });
            $(document).on('click', '[data-role~="delete-flag"]', function () {
                if (confirm("Are you sure you want to delete this flag?")) {
                    $(this).closest('[data-role="flag"]').find('[data-role="flag-delete-value"]').val(true);
                    $(this).closest('[data-role="flag"]').hide();
                    if ($('[data-role="flag"]:visible').length === 0) {
                        $(this).closest('[data-role="flag-edit-form"]').find('[data-role="flags"]').hide();
                    }
                }
            });

            $(document).on('change', "[data-role~='StartDateExpected']", function () {
                var startDate = new Date($("[data-role~='StartDateExpected']").val());
                $("[data-role~='StartDateActual']").val(startDate.toLocaleDateString());
                var defaultTermLength = parseInt($("#hdnDefaultTerm").val());
                var endDate = new Date(startDate.setYear(startDate.getFullYear() + defaultTermLength));
                endDate.setDate(endDate.getDate() - 1);
                $("[data-role~='EndDateExpected']").val(endDate.toLocaleDateString());
                $("[data-role~='EndDateActual']").val(endDate.toLocaleDateString());
            });
        },
        ConvertDate: function (date) {
            var yyyy = date.getFullYear().toString();
            var mm = (date.getMonth() + 1).toString();
            var dd = date.getDate().toString();

            var mmChars = mm.split('');
            var ddChars = dd.split('');

            return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
        }
    };
    return myCommittee;
}());